import type { TFunction } from 'i18next';
import { backendCode } from '@/api/errors';

// The rate-card codes the vendored contract names (TMMRSL-0076: TENANT_CURRENCY_NOT_PRICED isn't
// one, so it was dropped; TMMAPI-0154 retired two of the adopt and offer codes).
const RATE_CARD_ERRORS: Readonly<Record<string, string>> = {
  RATE_CARD_NOT_FOUND: 'rateCard.error.notFound',
  RATE_CARD_NOT_ACTIVE: 'rateCard.error.notActive',
  AGREEMENT_REQUIRED: 'rateCard.error.agreementRequired',
  RATE_CARD_ASSIGNMENT_RETIRED: 'rateCard.error.assignmentRetired',
};

/**
 * A translated message for tmm-api's rate-card codes; `null` for any other error. Callers fall
 * back to their usual message; the server's `message` is never shown for these.
 */
export function rateCardErrorMessage(err: unknown, t: TFunction): string | null {
  const code = backendCode(err);
  // `hasOwn`, so a code such as `constructor` never resolves to an `Object.prototype` member.
  if (code === undefined || !Object.hasOwn(RATE_CARD_ERRORS, code)) return null;
  return t(RATE_CARD_ERRORS[code] as string);
}
